







































import Vue from "vue";
import Component from "vue-class-component";
import DirectoryTable from "./components/DirectoryTable.vue";
import { scan } from "./api";

@Component({
  components: { DirectoryTable },
})
export default class PacksDirectory extends Vue {
  private massifPacks = [];
  private communityPacks = [];
  private loading = true;

  async mounted(): Promise<void> {
    scan()
      .then((res: any) => {
        console.log(res);
        this.communityPacks = res.data.community.Items;
        this.massifPacks = res.data.massif.Items;
        this.loading = false;
      })
      .catch((err) => {
        console.error(
          "There was an issue downloading the community content packs.",
          err
        );
        this.loading = false;
      });
  }
}
